import { render, staticRenderFns } from "./ANZHEADLINE.vue?vue&type=template&id=48a82fc7"
import script from "./ANZHEADLINE.vue?vue&type=script&lang=js"
export * from "./ANZHEADLINE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports